import React from 'react';
import SiteInfo from '../../Panels/EditSiteDialog/SiteInfo';

export default function SiteInputs({ site, handleSiteChange }) {
  return <SiteInfo site={site} handleChange={handleSiteChange} />;
}
